<template>
   <div class="layout layout-class">
      <BreadCrumbs>
         <template v-slot:actions>
            <Btn
               :text="{ do: 'Edit Class' }"
               action
               v-if="!currentClass?.archived"
               @handle-action="editClass"
            >
               <IconPencilFilled />
            </Btn>
            <h5 class="small red" v-else-if="currentClass?.archived">
               Class is Archived
            </h5>
         </template>
      </BreadCrumbs>
      <ClassHero />
      <div class="class-wrapper">
         <NuxtPage />
      </div>
      <ModalsEditClassModal :open="editing" @close="editing = false" />
   </div>
</template>
<script setup lang="ts">
import IconPencilFilled from "~/assets/images/icons/pencil-one-filled.svg?component";
const classesStore = useClassesStore();
const { currentClass } = storeToRefs(classesStore);

const editing = ref<boolean>(false);
const editClass = () => {
   editing.value = true;
};
</script>

<style lang="scss">
div.layout-class {
   div.class-nav {
      position: sticky;
      top: -1px;
   }
   div.class-wrapper {
      div.class {
         background: $background;
         min-height: 100dvh;
      }
   }
}
</style>
